import AnimatedDropDown from './AnimatedDropDown';

export default AnimatedDropDown;
